module.exports = __webpack_public_path__ + "static/img/news_top_01_1.25cf7052.gif";